import { webApiUrl } from "./constants";
import { LicenseChange } from "./interfaces/licenseChange";

export const getLicenseChanges = async (
  companyId: number,
  token: string
): Promise<LicenseChange[]> => {
  const request = new Request(`${webApiUrl}/LicenseChange/${companyId}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await fetch(request);

  if (response.ok) {
    const changes = await response.json();

    return changes;
  } else {
    return [];
  }
};
